import { defineComponent as _defineComponent } from 'vue'
import FireRiskSettingsLayout from './layouts/FireRiskSettings.layout.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'FireRiskSettings.page',
  setup(__props) {


return { __sfc: true,FireRiskSettingsLayout }
}

})